import validate from "/home/vladimir/Desktop/Projekti/marketNew/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/vladimir/Desktop/Projekti/marketNew/middleware/auth.global.js";
import manifest_45route_45rule from "/home/vladimir/Desktop/Projekti/marketNew/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-customer": () => import("/home/vladimir/Desktop/Projekti/marketNew/middleware/auth.customer.ts"),
  "auth-user": () => import("/home/vladimir/Desktop/Projekti/marketNew/middleware/auth.user.ts")
}